import { render, staticRenderFns } from "./CarouselImage.vue?vue&type=template&id=2fd6d789&scoped=true&"
import script from "./CarouselImage.vue?vue&type=script&lang=js&"
export * from "./CarouselImage.vue?vue&type=script&lang=js&"
import style0 from "./CarouselImage.vue?vue&type=style&index=0&id=2fd6d789&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fd6d789",
  null
  
)

export default component.exports